import { useMemo } from 'react';
import { Routes } from '@/routes';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';
import {
  LuLockKeyhole,
  LuChartColumnDecreasing,
  LuWallet,
  LuMessageSquareText,
  LuSettings,
  LuMessageCircleQuestion
} from 'react-icons/lu';

const iconClasses = 'text-[#58D36A] text-xl';

export default function useNavigationItems() {

  const [t] = useTranslation(['common']);

  return useMemo(() => {

    return [
      {
        path: Routes.UserWallet,
        title: t('common:labels.wallet'),
        icon: <LuWallet className={iconClasses} />,
        hide: envConfig.ui.removeWallet
      },
      {
        path: Routes.UserMessages,
        title: t('common:labels.messages'),
        icon: <LuMessageSquareText className={iconClasses} />
      },
      /*
      {
        path: Routes.UserFeedbacks,
        title: t('common:labels.feedback'),
        icon: <AppIcons.OutlineFeedbackIcon className={iconClasses} />
      },
      */
      {
        path: Routes.UserProfile,
        title: t('common:labels.change-password'),
        query: { scope: 'password' },
        icon: <LuLockKeyhole className={iconClasses} />,
        hide: envConfig.ui.removeChangePassword
      },
      {
        path: Routes.UserActivityReport,
        title: t('common:labels.activity-report'),
        icon: <LuChartColumnDecreasing className={iconClasses} />
      },
      {
        path: Routes.UserProfile,
        title: t('common:labels.settings'),
        icon: <LuSettings className={iconClasses} />
      },
      ...((!envConfig.ui.removeFAQ) ? [{
        path: Routes.FAQ,
        title: t('common:labels.common-questions'),
        icon: <LuMessageCircleQuestion className={'text-[#58D36A] text-[19px]'} />
      }] : []),
    ];
  }, [t]);

}
